export const getUserAgent = () => navigator?.userAgent;

export const userAgentIsGoogleBot = (userAgent: string) =>
  /googlebot|Google Page Speed Insights|Chrome-Lighthouse/i.test(userAgent);
